import { LoadingDots } from 'foundations-components/transitional/components/LoadingDots';
import FormCloningWarning from 'asset-actions-lib-forms/clone/components/FormCloningWarning';
import useHasWorkflows from 'asset-actions-lib-forms/clone/hooks/useHasWorkflows';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Taken from https://git.hubteam.com/HubSpot/submissions-ui/blob/3765824bb210d7f8fb69ba9adc433fa1eab89a17/submissions-ui/static/js/components/formCloning/FormCloningWarningWithFlows.js
 */
export default function FormCloningWarningWithFlows(props) {
  const {
    formGuid,
    formType
  } = props;
  const {
    hasWorkflows,
    loading
  } = useHasWorkflows({
    formType,
    guid: formGuid
  });
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingDots, {});
  }
  return /*#__PURE__*/_jsx(FormCloningWarning, Object.assign({
    formHasWorkflows: hasWorkflows,
    isBusinessUnitEnabled: false
  }, props));
}